import { MAX_SELECTED_NODES } from "@features/builder/CreateEdges/helpers"
import { EdgeDirection } from "@features/builder/CreateEdges/types"
import * as yup from "yup"

export const nodeSelectRule = yup
  .array()
  .min(1, "Select at least one target node")
  .max(MAX_SELECTED_NODES, `Select at most ${MAX_SELECTED_NODES} nodes`)
  .required()

export const createEdgesValidationSchema = yup.object({
  selectedNodes: nodeSelectRule,
  targetNodes: nodeSelectRule,
  direction: yup.mixed<EdgeDirection>().required(),
})
